import Repository from './Repository'
const action = 'profile/current'

export default {
  profile(fio, passport, email, birthday) {
    return Repository.post(action, {
      fio,
      passport,
      email,
      birthday,
    })
  },
  getProfile() {
    return Repository.get(action)
  },
}
